import type { ReactNode } from "react";
import { SystemIcon, type IconName } from "./SystemIcon";
export function DataPanel({
  title,
  subtitle,
  icon = "table",
  tools,
  children,
  className = "",
  bodyClassName = "",
}: {
  title: string;
  subtitle?: string;
  icon?: IconName | null;
  tools?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <section className={`data-panel ${className}`}>
      <header className="data-panel-header">
        <div className="data-panel-title">
          {icon && (
            <span className="data-panel-icon">
              <SystemIcon name={icon} />
            </span>
          )}
          <div>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
        </div>
        {tools && <div className="data-panel-tools">{tools}</div>}
      </header>
      <div className={`data-panel-body ${bodyClassName}`}>{children}</div>
    </section>
  );
}
export function ToolButton({
  icon,
  label,
  onClick,
  disabled = false,
  variant = "secondary",
  compact = false,
}: {
  icon: IconName;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: "primary" | "secondary" | "ghost";
  compact?: boolean;
}) {
  return (
    <button
      type="button"
      className={`tool-button ${variant} ${compact ? "compact" : ""}`}
      title={label}
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
    >
      <SystemIcon name={icon} />
      <span>{label}</span>
    </button>
  );
}
